<template>
  <div class="Contabil container">
    <h3>Gerador de Arquivos Contabéis</h3>
    <hr/>
    <div>
      <p>Importe aqui um arquivo .csv, contendo os dados organizados no seguinte layout: <i>CNPJ/CPF;Valor;</i></p>
      <p>Salve os dados do arquivo no formato de texto para importação</p>
    </div>
    <div class="row">
      <div class="col-12 text-center"
           v-bind:class="{
                    'bg-sucess': !file1,
                    'bg-warning': Boolean(file1)
            }">
        <b-form-group label="Arquivo (.csv) *">
          <b-file
            name="file1"
            v-model="file1"
            v-on:change="parseFile"
            :accept="fileTypes.join(',')"
            required
          />
        </b-form-group>
      </div>
    </div>
    <div class="col-12 text-center">
      <b-btn variant="success" v-on:click="runProcessamento">
        Gerar
      </b-btn>
    </div>
  </div>
</template>

<script>
  import Papa from "papaparse";
  import uuid4 from "uuid4";

  function download(arr) {
    const csv = Papa.unparse(arr, {delimiter: ";", header: false});
    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;"
    });
    const filename = uuid4();

    if (window.navigator.msSaveOrOpenBlob)
      window.navigator.msSaveBlob(blob, `${filename}.csv`);
    else {
      var a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, { type: "text/csv" });
      a.download = `${filename}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  export default {
    data: () => {
      return {
        fileTypes: [".csv"],
        file1: null,
        file1Data: [],
      }
    },
    methods : {
      cleaninscrFederal: function(inscrFederal) {
        inscrFederal = inscrFederal.replace('/', '');
        inscrFederal = inscrFederal.replace('.', '');
        inscrFederal = inscrFederal.replace('.', '');
        inscrFederal = inscrFederal.replace('-', '');

        return inscrFederal;
      },

      moneyReformat: function(money){
        let valueString = money.toString();
        let stringMoney = valueString.replace(',', '.');
        return parseFloat(stringMoney);
      },

      prepareData: function (data) {
        data.map(item => {
          item[0] = this.cleaninscrFederal(item[0]);
          item[1] = this.moneyReformat(item[1]);
        });

        return data;
      },

      preparaArray: function(data)  {
        const dados = this.prepareData(data);

        const mapArray = [];

        dados.map(item => {
          const data = {
            cnpj: item[0],
            valor: item[1]
          };

          mapArray.push(data);
        });

        return mapArray;
      },

      getKeys: function (data) {
        const arrayKeys = [];
        data.map(item => {
          arrayKeys.push(item.cnpj);
        });

        return arrayKeys.sort();
      },

      indexExiste: function (array, valor) {
        return array.findIndex(pos => {
          if (pos.cnpj.length === 14 && pos.cnpj.substring(0,8) === valor) return true;
          if (pos.cnpj === valor) return true;
          return false;
          });
      },

      formataCpfCnpj: function(valor) {
        if (valor.length === 11) return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        if (valor.length === 14) return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        return valor;
      },

      formataValor: function (valor){
        return valor.toFixed(2).replace('.', ',');
      },

      getKey : function (keys, rootCnpj){
        return keys.find((pos) => {
          if (pos.length === 14){
            const rootIndex = pos.substring(0,8);
            if (rootIndex === rootCnpj){
              return pos;
            }
          } else {
            if (pos === rootCnpj){
              return pos;
            } 
            return '00000000000000';
          }
        });
      },

      generateValorTotal: function(array, rootCnpj){
        let valorAcumulado = 0; 
        
        array.map((pos) => {
          const cnpj = pos.cnpj;
          const valor = pos.valor;
          if (cnpj.length === 14){
            if (cnpj.substring(0, 8) === rootCnpj) {
              valorAcumulado += valor;
            }
          } else {
            if (cnpj === rootCnpj){
              valorAcumulado += valor;
            }
          }
        });

        return valorAcumulado;
      },

      runProcessamento : function (){
        const data = this.file1Data;
        const arrayInfo = this.preparaArray(data);
        const keys = this.getKeys(arrayInfo);
        const resultados = [];

        arrayInfo.sort().map((pos) => {
          // Pega os valores de cada posição
          const cnpj = pos.cnpj;
          let rootCnpj = '';

          // Caso seja CNPJ, captura apenas a raiz do mesmo
          if (cnpj.length === 14) {
            rootCnpj = cnpj.substring(0, 8);
          } else {
            rootCnpj = cnpj;
          }

          // Verifica se o index em questão já existe dentro do array de resultados
          const existeResultados = this.indexExiste(resultados, rootCnpj);
          const cnpjAcumulador = this.getKey(keys, rootCnpj);

          // Se o resultado não existir dentro das respostas, insere no array
          if (existeResultados == -1){
            const valorAcumulado = this.generateValorTotal(arrayInfo, rootCnpj);
            let toPush = {
              cnpj: cnpjAcumulador,
              valor: valorAcumulado
            }
            resultados.push(toPush);
          }

        });

        resultados.map((pos) => {
          pos.cnpj = this.formataCpfCnpj(pos.cnpj);
          pos.valor = this.formataValor(pos.valor);
        })

        download(resultados);
      },

      parseFile: function (event){
        const file = event.target.files[0];
        const orign = event.target.name;

        Papa.parse(file, {
          header: false,
          trimHeaders: false,
          encoding: 'ascii',
          skipEmptyLines: true,
          delimiter: ";",
          complete: (results) => {
            this.setData(results.data, orign)
          }
        });
      },
      setData: function (data, origin){
        switch (origin) {
          case "file1":
            this.file1Data = data;
            break;
          default:
            console.log('Formato de arquivo inválido!')
        }
      }
    }
  }
</script>